module.exports = __webpack_public_path__ + "login-form-6b98a2b5/energizer-8a21a7d8e3ec609336fc8b362b4119b2.jpeg";